import { NgModule,  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { PhoneNumberFormatService } from 'src/app/phone-number-format.service';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule,  } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { CheckBoxSelectionService, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { MyDatePickerModule } from 'mydatepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule  } from '@syncfusion/ej2-angular-calendars';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CalendarScheduleComponent } from './calendar-schedule.component';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { AgendaService, DayService, DragAndDropService, MonthAgendaService, MonthService,  ScheduleModule,  TimelineMonthService, TimelineViewsService, WeekService, WorkWeekService } from '@syncfusion/ej2-angular-schedule';
import { CalendarScheduleRoutingModule } from './calendar-schedule-routing.module';
import { EventsModule } from '../events/events.module';
@NgModule({
  declarations: [CalendarScheduleComponent],
  exports: [CalendarScheduleComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    RadioButtonModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MultiSelectModule,
    MyDatePickerModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgSelectModule,
    ScheduleModule,
    TreeViewModule,
    CalendarModule,
    CalendarScheduleRoutingModule,
    EventsModule
  ],
  providers: [ColumnChooserService,PhoneNumberFormatService,PageService,SortService,FilterService, ResizeService,CheckBoxSelectionService,
    DayService, WeekService, WorkWeekService, MonthService, AgendaService, MonthAgendaService, TimelineViewsService, TimelineMonthService,DragAndDropService
  ],
})
export class CalendarScheduleModule { }
